import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

import { catchError, first, tap } from 'rxjs/operators';
import { ApiService } from '../services/api.service';
import { of } from 'rxjs';
import { Itin } from '../core/itinerari/itinerari.model';
import { ItinActionService } from '../core/itinerari/itinerari.action';

@Injectable()
export class SingleItinResolver implements Resolve<Itin> {

  constructor(private service: ApiService,
              private itinAction: ItinActionService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const actualRoute = state.url;
    const idFromUrl = parseInt(actualRoute.split('/').pop(), 10);
    return this.service.itinDetail(idFromUrl).pipe(
      first(),
      tap((data: any) => {
        this.itinAction.setItinCurrent(Itin.from(data));
      }),
      catchError((err) => {
        console.error('Non è stato possibile recuperare il singolo Itinerario');
        return of(err);
      })
    );
  }
}
